import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { Router } from "@angular/router";
import { Subject, takeUntil } from "rxjs";
import { EcoCostService } from "src/app/services/eco-cost/eco-cost.service";
import { ThemeService } from "src/app/services/theme/theme.service";
import { environment } from "src/environments/environment";

@Component({
  selector: "pro-proforma-footer",
  templateUrl: "./proforma-footer.component.html",
  styleUrls: ["./proforma-footer.component.css"],
})
export class ProformaFooterComponent implements OnInit, OnDestroy{
  @Input() showBotaoFiltro = false;
  @Input() showFiltroInspiracao = false;
  @Input() showFiltroMaterial = false;
  @Input() showPularInspiracao = false;
  @Input() showQueroParede = false;
  @Input() showQueroPiso = false;
  @Input() showBotaoAvancar = false;
  @Input() showTotalObra = false;
  @Input() showTotalObraProduto = false;
  @Input() showComprarLista = false;
  @Input() precoObra: null | number = null;
  @Input() precoObraProduto: null | number = null;
  @Input() leftAlign = false;

  @Input() disableQueroParede = false;
  @Input() disableQueroPiso = false;
  @Input() disableAcancar = false;
  @Input() disableVerTotalObra = false;

  @Output() onClickBotaoFiltro = new EventEmitter<void>();
  @Output() onClickPularInspiracao = new EventEmitter<void>();
  @Output() onClickQueroParede = new EventEmitter<void>();
  @Output() onClickQueroPiso = new EventEmitter<void>();
  @Output() onClickBotaoAvancar = new EventEmitter<void>();
  @Output() onClickMostrarPreco = new EventEmitter<void>();
  @Output() onClickComprarLista = new EventEmitter<void>();

  isDarkMode: boolean;
  isReformaPath: boolean;
  isTextoAvancar: boolean;
  isFinancialCost: boolean;
  isRevestimentoPath: boolean;
  isPreexistancePath: boolean;

  isProCarbonoMode: boolean = environment.proCarbono;
  dev = environment.dev;

  private destroy$ = new Subject<void>();

  constructor(private themeService: ThemeService, private router: Router, private ecoCostService: EcoCostService) {}

  ngOnInit(): void {
    this.isDarkMode = this.themeService.isDarkMode();
    this.isReformaPath = this.isCurrentPath('/reforma');
    this.isRevestimentoPath = this.isCurrentPath('/revestimento') && !this.isCurrentPath('/revestimento/piso-nao-selecionado');
    this.isPreexistancePath = this.isCurrentPath('/revestimento/piso-selecionado');
    this.isTextoAvancar = this.isCurrentPath('/revestimento') || this.isCurrentPath('/revestimento/piso-nao-selecionado');
    console.log(this.isPreexistancePath)
    this.ecoCostService.isFinancialCost$.pipe(takeUntil(this.destroy$)).subscribe(isFinancialCost => this.isFinancialCost = isFinancialCost);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  isCurrentPath(path: string): boolean {
    return this.router.url.includes(path);
  }

  toggleEcoCost(): void {
    if(this.isProCarbonoMode) this.ecoCostService.toggleValue();
  }

  clickBotaoFiltroHandler() {
    this.onClickBotaoFiltro.emit();
  }

  clickPularInspiracaoHandler() {
    this.onClickPularInspiracao.emit();
  }

  clickQueroParedeHandler() {
    this.onClickQueroParede.emit();
  }

  clickQueroPisoHandler() {
    this.onClickQueroPiso.emit();
  }

  clickBotaoAvancarHandler() {
    this.onClickBotaoAvancar.emit();
  }

  clickMostrarPrecoHandler() {
    this.onClickMostrarPreco.emit();
  }

  clickComprarListaHandler() {
    this.onClickComprarLista.emit();
  }
}
